import axios from "../api/axios";
import config from '../config/config';

export function getEnvironments() { 
    return postData('GetDocsEnv', {})
        .then((data) => data.Data);
}

export function getEnvironmentById(id) {
    return postData('GetDocsEnvById', { "Id": id })
        .then((data) => data.Data.Files); 
}

export function deleteEnvironment(id) {
    return postData('DeleteDocsEnv', {
        "Id": id
    }).then((data => data.Data));
}

export function createEnvironment(env) {
    return postData('CreateDocsEnv', {
        "Name": env.Name, 
        "FolderName": env.FolderName, 
        "RoleId": env.RoleId
    }).then((data) => data.Data);
}

export function deleteFiles(ids) {
    return postData('FilesToBeDeleted', {
        "ids" : [ids]
    }).then((data) => data.Data);
}

function postData(intent, data) { 
    var promise = new Promise(function (resolve, reject) { 
      axios
        .post(config.endPoint + '/api/millai/prompt', 
            JSON.stringify({ Intent: intent, data: data }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        })
        .then((response) => {       
            let obj = JSON.parse(response.data);
            resolve(obj);
        })
        .catch((error) => {
            console.log(error);
            reject(error);
        });
    });

    return promise;
}


